module.exports = __webpack_public_path__ + "img/skate_bronze.c35566be.png";